<template>
  <div class="upload-wapper">
    <el-upload
      ref="upload"
      :action="uploadUrl"
      :on-success="afterSuccess"
      :on-error="handleError"
      :data="{ type: type || fileType }"
      :on-change="onChange"
      :limit="limit"
      :on-exceed="onExceed"
      :before-upload="beforeUpload"
      drag
      with-credentials
      multiple
    >
      <i class="el-icon-upload" />
      <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
      <div v-for="(err, index) in errors" slot="tip" :key="err.file" class="el-upload__tip">
        <span class="error-name">{{ err.file }}</span> <span class="error-msg">{{ err.message }}</span>
        <span class="error luxun" @click="removeError(index)">无视它</span>
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    type: { type: String, default: '' },
    label: { type: String, default: undefined },
    limit: { type: Number, default: undefined },
    onSuccess: { type: Function, default: () => {} },
    onError: { type: Function, default: () => {} },
    onExceed: { type: Function, default: () => {} },
    beforeUpload: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {
      uploadUrl: `${window.host}/uploads`,
      uploadingFiles: [],
      errors: [],
      fileType: '',
    }
  },
  methods: {
    clean() {
      this.errors = []
      this.$refs.upload && this.$refs.upload.clearFiles()
    },
    onChange(file, fileList) {
      const { label, fileType } = this
      const _label = label || fileType
      if (_label) {
        const uploadingFiles = this.uploadingFiles
        const index = uploadingFiles.findIndex(val => file.uid === val)
        if (index === -1) {
          file.name = `( ${_label} ) ${file.name}`
          uploadingFiles.push(file.uid)
        }
      }
    },
    handleError(err, file, fileList) {
      this.errors.push({
        file: file.name,
        message: err.message,
      })
      this.onError(err, file, fileList)
    },
    removeError(index) {
      this.errors.splice(index, 1)
    },
    afterSuccess(response, file, fileList) {
      this.onSuccess(response, file, fileList)
      this.$emit('uploaded', response)
    },
  },
}
</script>

<style>
.upload-wapper .el-upload,
.upload-wapper .el-upload-dragger {
  width: 100%;
}
.upload-type {
  margin: 0 0 10px 0;
}
.el-upload__tip {
  position: relative;
  padding-right: 38px;
}
.luxun {
  position: absolute;
  right: 0;
  top: 0;
}
.error-name {
  color: #f56c6c;
}
.error-msg {
  color: #909399;
}
.error:hover {
  color: #f56c6c;
  cursor: pointer;
}
</style>
